let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8G72n")).then(() => parcelRequire('lIt3y'));